import ajax from "@/lib/ajax";
import { beforeSend } from "@/views/zhiji/js/services/service";
import widgetManager from "@/views/zhiji/js/modules/questionEdit/widgets/widgetManager.js";
import { uniqueId } from "@/views/zhiji/js/common/util.js";
import { MessageBox } from 'element-ui';

const URLs = {
    RPA_DETAIl: "/xiaoyue-operation/rpa/detail", // 流程图详情
    RPA_UPDATE: "/xiaoyue-operation/rpa/update", // 流程图更新
    ADD_NODE: "/xiaoyue-operation/rpa/node/add", // 新增节点
    UPDATE_NODE: "/xiaoyue-operation/rpa/node/update", // 修改节点
    DELETE_NODE: "/xiaoyue-operation/rpa/node/delete", // 删除节点
    GET_NODE_DETAIL: "/xiaoyue-operation/rpa/node/details", // 获取节点详情
    GET_OPERATE_LIST: "/xiaoyue-operation/rpa/condition_group/operate/list", // 获取操作符列表
    GET_CONDITION_GROUP_LV_LIST: "/xiaoyue-operation/rpa/condition_group/option/list", // 条件组下拉表的列表
    MODIFY_ALONE_RPA_STATUS: "/xiaoyue-operation/rpa/status/update" // rpa上线、保存
};
const nodeTypMap = {
    "1": "Condition",
    "2": "Action",
    Action: "2",
    Condition: "1"
};

// ===================== 获取流程图节点和链接 =========================
export async function queryRpaDetail(rpaId) {
    const request = { rpa_id: rpaId };
    beforeSend(request);
    let ret = null;
    try {
        const resp = await ajax.get(URLs.RPA_DETAIl, { ...request });
        const { node_list = [], relations = "[]", positions = "{}" } = resp;
        const connectors = JSON.parse(relations);
        const positionMap = JSON.parse(positions);
        const nodes = node_list.map(n => {
            const name = n.node_name;
            const nodeType = nodeTypMap[n.node_type];
            const position = positionMap[n.node_id] || {};
            return {
                name,
                nodeType,
                id: n.node_id,
                rpaId: n.rpa_id,
                position: { x: position.left, y: position.top },
                ...convertByNodeType(nodeType, n)
            };
        });
        ret = {
            rpaName: resp.rpa_name,
            nodes,
            connectors,
        };
    } catch (err) {
        console.error(err);
        // TODO
    }
    return ret;
}
function convertByNodeType(nodeType, node) {
    const handlers = {
        Action: toActionNode,
        Condition: toConditionNode
    };
    return handlers[nodeType](node);
}
function toActionNode(node) {
    return {
        actions: node.action_groups.map(a => {
            return {
                actionId: a.action_group_id,
                desc: `执行「${node.node_name}」`
            };
        })
    };
}
function toConditionNode(node) {
    return {
        conditions: node.condition_groups.map(a => {
            return {
                conditionId: a.condition_group_id,
                conditionName: a.condition_group_name,
                isElse: a.is_else_condition
            };
        })
    };
}
// ==============================================================

// ===================== 修改流程图节点和连线 =====================
export async function updateRpaFlow({ rpaId, connectors, nodes, rpaName }) {
    const relations = connectors || [];
    const positions = {};
    nodes.forEach(node => {
        positions[node.id] = { top: node.position.y, left: node.position.x };
    });
    const request = {
        rpa_id: rpaId,
        rpa_name: rpaName,
        status: 0,
        relations: JSON.stringify(relations),
        positions: JSON.stringify(positions)
    };
    beforeSend(request);
    const resp = await ajax.post(URLs.RPA_UPDATE, request);
    return resp;
}
// ==============================================================

// =================== 新增节点 ========================
export async function addRpaNode({ rpaId, nodeType }) {
    const request = {
        rpa_id: rpaId,
        node_type: nodeTypMap[nodeType],
        node_name: "",
        content: "[]"
    };
    beforeSend(request);
    const resp = await ajax.post(URLs.ADD_NODE, request);
    return {
        id: resp.node_id
    };
}
// ======================================================

// ===================== 删除节点 ===================
export async function deleteRpaNode({ rpaId, nodeId }) {
    const request = {
        rpa_id: rpaId,
        node_id: nodeId,
    };
    beforeSend(request);
    const resp = await ajax.post(URLs.DELETE_NODE, request);
    return resp;
}
// =================================================

// ================== 获取动作节点详情 ================
export async function getRpaActionNodeDetail({ rpaId, nodeId }) {
    const request = {
        rpa_id: rpaId,
        node_id: nodeId,
    };
    const typeMap = { message: "SendAction", issue: "IssueAction" };
    beforeSend(request);
    const resp = await ajax.get(URLs.GET_NODE_DETAIL, request);
    const actionGroup0 = resp.action_groups.length ? resp.action_groups[0] : { type: "", content: "{}" };
    const content = JSON.parse(actionGroup0.content)[0] || {};
    return {
        actionName: resp.node_name,
        actionId: actionGroup0.action_group_id,
        actionType: typeMap[content.type] || "",
        actionContent: convertActionContentFromServer(typeMap[content.type], content.val)
    };
}
function convertActionContentFromServer(actionType, val) {
    const handlers = {
        IssueAction: convertIssueContentFromServer,
        SendAction: convertSendContentFromServer,
    };
    return handlers[actionType] ? handlers[actionType](val) : "";
}
function convertIssueContentFromServer() {
    return { close: true };
}
function convertSendContentFromServer(val) {
    const map = {
        text: "LinkTextInput",
        form: "QuestionForm"
    };
    const contents = JSON.parse(val.content);
    return contents.map(c => {
        const coverted = widgetManager.serverMap[c.type].server2Client(c);
        return { ...coverted, wtType: map[c.type] };
    });
}
// ==================================================

// ================== 修改动作节点详情 =================
export async function updateRpaActionNode(rpaData) {
    const request = {
        rpa_id: rpaData.rpaId,
        node_id: rpaData.nodeId,
        node_type: nodeTypMap[rpaData.nodeType],
        node_name: rpaData.actionName,
        content: [convertActionContent2Server(rpaData.actionType, rpaData.actionContent, rpaData.actionId)],
    };
    beforeSend(request);
    const resp = await ajax.post(URLs.UPDATE_NODE, request);
    return resp;
}
function convertActionContent2Server(actionType, content, actionId) {
    const handlers = {
        IssueAction: convertIssueContent2Server,
        SendAction: convertSendContent2Server,
    };
    return {
        opt: actionId ? "update" : "add",
        action_group_id: actionId || "",
        action_group_name: "",
        content: [handlers[actionType](content)]
    };
}
function convertIssueContent2Server() {
    return {
        type: "issue",
        action: "close",
        val: {}
    };
}
function convertSendContent2Server(content) {
    const map = {
        LinkTextInput: "text",
        QuestionForm: "form"
    };
    return {
        type: "message",
        action: "reply",
        val: {
            content: JSON.stringify(
                content.map(c => {
                    const coverted = widgetManager.serverMap[map[c.wtType]].client2Server(c);
                    return { ...coverted };
                })
            )
        }
    };
}
// ==================================================

// ================== 获取动作节点详情 ================
export async function getRpaConditionNodeDetail({ rpaId, nodeId }, params) {
    const request = {
        rpa_id: rpaId,
        node_id: nodeId,
    };
    beforeSend(request);
    const resp = await ajax.get(URLs.GET_NODE_DETAIL, request);
    const { node_name: nodeName = "", condition_groups: conditionGroups = [] } = resp;
    const { isSupply, groups, elseGroupId } = convertConditionsFromServer(conditionGroups, params);
    return {
        nodeName,
        isSupply,
        groups,
        elseGroupId,
    };
}
function convertConditionsFromServer(conditionGroups, params) {
    const groups = [];
    let isSupply = false;
    let elseGroupId = "";
    const doCircle = (node, level) => {
        const connParamName = ["", "term_group", "child_term_group"][level];
        let connector = node[connParamName];
        if (level === 1) {
            connector = ["", "AND", "OR"][connector];
        }
        const children = [];
        (node.child_group || []).forEach(child => {
            children.push(doCircle(child, level + 1));
        });
        let value = null;
        if (level === 3) {
            const foundParam = params.find(p => p.value.value === node.LV.key);
            value = {
                param: foundParam
                    ? foundParam.value
                    : {
                          value: node.LV.key,
                          param: node.LV.param,
                          type: node.LV.type
                      },
                op: node.OP,
                val: node.RV.value
            };
        }
        return {
            uId: uniqueId(),
            type: ["Group", "Group", "Group", "Condition"][level],
            connector: connector || "",
            level,
            children,
            value,
        };
    };
    conditionGroups.forEach(cg => {
        if (cg.is_else_condition) {
            isSupply = true;
            elseGroupId = cg.condition_group_id;
            return;
        }
        cg.child_group = JSON.parse(cg.content);
        groups.push({
            updateState: "",
            groupName: cg.condition_group_name,
            groupId: cg.condition_group_id,
            conditions: doCircle(cg, 1),
        });
    });
    return {
        isSupply,
        groups,
        elseGroupId,
    };
}
// ==================================================

// ================== 修改动作节点详情 ================
export async function updateRpaConditionNode({ rpaId, nodeId, nodeType, nodeName, isSupply, groups, elseGroupId }) {
    const request = {
        rpa_id: rpaId,
        node_id: nodeId,
        node_type: nodeTypMap[nodeType],
        node_name: nodeName,
        content: convertConditions2Server(groups, isSupply, elseGroupId),
    };
    beforeSend(request);
    const resp = await ajax.post(URLs.UPDATE_NODE, request);
    return resp;
}
function convertConditions2Server(groups, isSupply, elseGroupId) {
    const ret = [];
    const doCircle = (condition) => {
        if (condition.level === 3) {
            const { value } = condition;
            return {
                LV: {
                    type: value.param.type,
                    key: value.param.value,
                    param: value.param.param,
                    value: "",
                },
                OP: value.op,
                RV: {
                    type: "",
                    key: "",
                    param: "",
                    value: value.val
                }
            };
        }
        const children = [];
        (condition.children || []).forEach(child => {
            children.push(doCircle(child));
        });
        return {
            child_term_group: condition.connector,
            child_group: children,
        };
    };
    groups
        .filter(cg => cg.updateState !== "")
        .forEach(cg => {
            ret.push({
                opt: cg.updateState,
                condition_group_id: cg.groupId || "",
                condition_group_name: cg.groupName,
                is_else_condition: 0,
                term_group: { AND: 1, OR: 2 }[cg.conditions.connector] || "",
                content: doCircle(cg.conditions).child_group,
            });
        });
    if (isSupply && !elseGroupId) {
        ret.push({
            opt: "add",
            condition_group_id: "",
            condition_group_name: "else",
            is_else_condition: 1,
            term_group: 0,
            content: "[]"
        });
    }
    if (!isSupply && elseGroupId) {
        ret.push({
            opt: "delete",
            condition_group_id: elseGroupId,
            condition_group_name: "else",
            is_else_condition: 1,
            term_group: 0,
            content: "[]"
        });
    }
    return ret;
}
// ==================================================

// ================= 获取操作符列表 ==================
export async function getOperateList() {
    const request = {};
    beforeSend(request);
    const resp = await ajax.get(URLs.GET_OPERATE_LIST, request);
    return resp;
}
// ==================================================

// ================= 获取条件组列表 ==================
export async function getConditionLVList() {
    const request = {};
    beforeSend(request);
    const resp = await ajax.get(URLs.GET_CONDITION_GROUP_LV_LIST, request);
    return resp.map(item => ({
        label: item.name,
        value: {
            value: item.key,
            param: item.param,
            type: item.type,
            valType: item.val_type,
            options: item.options
        }
    }));
}
// ==================================================
// =============修改rpa状态（单个）=============
export async function updateRpaStatus(reqData) {
    const request = {
        rpa_ids: reqData.rpaIds,
        status: reqData.status
    };
    beforeSend(request);
    try {
        const result = await ajax.post(URLs.MODIFY_ALONE_RPA_STATUS, request);
        return result;
    } catch (error) {
        const { response } = error;
        MessageBox.confirm(response.data.err_msg, "提示", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning"
        });
        return error;
    }
}
